import { NumberPlateScanComponent } from "./component/number-plate-scan/number-plate-scan.component";
import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { YardSimulatorComponent } from "./component/yard-simulator.component";
import { ApplicationClientCommonModule, MaterialModule } from "@sdbn/appclient";
import { SharedModule } from "src/app/shared/shared.module";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { RfidReaderComponent } from "./component/rfid-reader/rfid-reader.component";
import { BarcodeReaderComponent } from "./component/barcode-reader/barcode-reader.component";

@NgModule({
  imports: [
    CommonModule,
    ApplicationClientCommonModule,
    MaterialModule,
    SharedModule,
    FormsModule,
    ReactiveFormsModule,
  ],
  declarations: [
    YardSimulatorComponent,
    NumberPlateScanComponent,
    RfidReaderComponent,
    BarcodeReaderComponent,
  ],
})
export class YardSimulatorModule {}
